import styles from './index.module.css'
import classnames from 'classnames'

export const View = ({ width, fontSize, children, className, ...props }) => {
    return (
        <button type="button" style={{ width, fontSize }} className={classnames(styles.default, className)} {...props}>
            {children}
        </button>
    )
}
